export const isAuthorized = () =>
  sessionStorage.getItem('isAuthorized') !== 'false';

export const setIsAuthorized = (authorized: boolean) => {
  sessionStorage.setItem('isAuthorized', authorized ? 'true' : 'false');
};
